module.exports = __webpack_public_path__ + "img/logo.310a24e2.png";